import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#099250',
        },
        secondary: {
            main: '#ff9b00',
        },
    },
});


export {  theme };

